// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"WeddingSpaces--wrapper","spinnerContainer":"WeddingSpaces--spinnerContainer","iframe":"WeddingSpaces--iframe"};